import React from "react";
import PropTypes from 'prop-types'
import {CommonFields, DefaultFields, getAdditionalFields} from "./FieldsForProperties";
import {del} from "object-path-immutable";


const Properties = ({selectedField, selectedPath, setValue, onChangeSelectedProps, nameRef}) => {

    const onChange = (value, path) => {
        if (selectedField) {
            if (path === 'valueGenerator' && !value) {
                const newField = del(selectedField.field, 'generateWhenEmpty')

                setValue({
                    ...newField,
                    valueGenerator: value,
                }, `properties.${selectedPath}`);

                onChangeSelectedProps({
                    ...newField,
                    valueGenerator: value,
                })
                return
            }

            const isOverridable = Boolean(selectedField.field && selectedField.field.overridable);
            setValue(value, `properties.${selectedPath}`, path, isOverridable);
            onChangeSelectedProps(value, path, isOverridable)
        }
    };

    return (
        <div>
            <DefaultFields
                setValue={onChange}
                values={selectedField.field}
                disabled={selectedPath ? selectedField.disabled : true}
                overridable={selectedPath ? selectedField.field.overridable : false}
                nameRef={nameRef}
            />
            {getAdditionalFields(
                selectedField.field.type,
                selectedField.field,
                onChange,
                selectedPath ? selectedField.disabled : true,
                selectedPath ? selectedField.field.overridable : false
            )}
            <CommonFields
                values={selectedField.field}
                setValue={onChange}
                disabled={selectedPath ? selectedField.disabled : true}
                overridable={selectedPath ? selectedField.field.overridable : false}
            />
        </div>
    )
};
export default Properties

Properties.propTypes = {
    selectedField: PropTypes.object,
    selectedPath: PropTypes.string,
    setValue: PropTypes.func,
    onChangeSelectedProps: PropTypes.func
};
Properties.defaultProps = {
    selectedField: {},
};